import { useEffect } from 'react'
import {
	useUser,
} from './data'
import {
	setAnalyticsUserId,
} from './firebase'

const AnalyticsLogger = () => {

    const user = useUser()

    // const info = useStoreUserInfo()

    // console.log('AnalyticsLogger.js', info)

    //
    // Register user with Firebase Analytics
    //
    useEffect(() => {
        if (user) {

            console.log('Register user with FirebaseAnalytics')

            setAnalyticsUserId(user?.uid)

        }
    }, [ user ])

	/*
    const activeSubscriptions = info?.activeSubscriptions

    useEffect(() => {
        if (activeSubscriptions) {
            console.log('Set user property', activeSubscriptions)
            setAnalyticsUserProperty('subscriptions', activeSubscriptions)
        }
    }, [ activeSubscriptions ])
	*/

    return null
}

export default AnalyticsLogger
